import { render, staticRenderFns } from "./Juego.vue?vue&type=template&id=436cd47a&scoped=true&"
import script from "./Juego.vue?vue&type=script&lang=js&"
export * from "./Juego.vue?vue&type=script&lang=js&"
import style0 from "./Juego.vue?vue&type=style&index=0&id=436cd47a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436cd47a",
  null
  
)

export default component.exports